import React from 'react';
const ArrowDownIcon = ({
    width = "14",
    height = "8",
    viewBox="0 0 14 8",
    fill = "#727580",
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={'none'}
        {...props}
    >
        <path
            d="M6.98978 5.49734L1.74504 0.287419C1.54537 0.0890694 1.30439 -0.0066185 1.02212 0.000355721C0.740058 0.0071249 0.499189 0.109684 0.299513 0.308034C0.0998377 0.506179 0 0.748834 0 1.036C0 1.32317 0.0998377 1.56593 0.299513 1.76428L6.26717 7.69232C6.47366 7.89744 6.71453 8 6.98978 8C7.26503 8 7.5059 7.89744 7.71239 7.69232L13.7008 1.74366C13.9003 1.54552 14 1.30625 14 1.02585C14 0.74545 13.9003 0.506179 13.7008 0.308034C13.5011 0.109684 13.2567 0.0105085 12.9677 0.0105085C12.6786 0.0105085 12.4342 0.109684 12.2345 0.308034L6.98978 5.49734Z"
            fill={fill}
        />
    </svg>
);

export { ArrowDownIcon };
